<template>
    <div class="col-12 status-card" v-if="monitor">
        <section class="container my-3 px-0">
            <div class="row mb-2">
                <span class="col-lg-6 col-md-12 monitor-name text-left">{{ monitor.monitorName }}</span>
                <span class="col-lg-6 col-md-12 text-lg-right monitor-status" :class="[status]" v-if="loaded">{{
                    statusLabel
                }}</span>
            </div>
            <div class="row">
                <div class="col-12 monitor">
                    <svg preserveAspectRatio="none" height="34" :viewBox="daysWidth" v-if="!loaded">
                        <Tick v-for="(event, index) in dummyEvents" :id="index" />
                    </svg>
                    <svg preserveAspectRatio="none" height="34" :viewBox="daysWidth" v-if="loaded">
                        <Tick v-for="(event, index) in events" :eventDetails="event" :id="index" />
                    </svg>
                </div>
            </div>
            <div class="row legend align-items-center">
                <span class="col-2 col-md-1 pr-0">{{ daysValue }} Days</span>
                <span class="col-2 col-md-4 p-1"><hr /></span>
                <span class="col-4 col-md-2 text-center uptime p-0" v-if="loaded">{{ uptime }} % uptime</span>
                <span class="col-4 col-md-2 text-center uptime p-0" v-if="!loaded">loading ...</span>
                <span class="col-2 col-md-4 p-1"><hr /></span>
                <span class="col-2 col-md-1 text-right pl-0">Today</span>
            </div>
        </section>
    </div>
</template>

<script>
import ApiRequest from '../../utilities/apiRequest'
import { useStore } from 'vuex'

// lodash components
import range from 'lodash/range'
import meanBy from 'lodash/meanBy'
import round from 'lodash/round'

export default {
    props: ['monitor'],
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    data() {
        return {
            events: [],
            dummyEvents: [],
            loaded: false,
        }
    },
    mounted: function () {
        for (let i in range(0, 90, 1)) {
            this.dummyEvents.unshift(null)
        }
        this.getMonitorEvents()
    },
    methods: {
        getMonitorEvents: function () {
            ApiRequest.get(this.$store, this.url(`/api/v2/status/uptime/${this.monitor.entityGuid}/events`)).then(
                data => {
                    //always have 90 events
                    for (let i in range(0, 90 - data.length, 1)) {
                        data.unshift(null)
                    }
                    this.events = data
                    this.loaded = true
                },
            )
        },
    },
    computed: {
        daysValue: function () {
            return this.$grid.breakpoint === 'xs' ? 30 : 90
        },
        daysWidth: function () {
            return this.$grid.breakpoint === 'xs' ? '300 0 148 34' : '0 0 453 34'
        },
        statusLabel: function () {
            const status = this.$t(`status.operation.${this.status}`)
            return status.charAt(0).toUpperCase() + status.substring(1)
        },
        status: function () {
            let statusLabel = ''
            if (this.monitor.uptime === 0) {
                statusLabel = 'bad'
            }
            if (this.monitor.uptime === 100) {
                statusLabel = 'good'
            }
            if (this.monitor.uptime < 100) {
                statusLabel = 'ok'
            }
            return statusLabel
        },
        uptime: function () {
            if (this.events.length > 0) {
                return round(
                    meanBy(this.events, event => (event !== null ? event.uptime : 0)),
                    2,
                )
            } else {
                return 100
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/gutter-size';
@import '~scss/mixins/rem';

.status-card {
    background: var(--white);
    border: 1px solid #e5e5e5;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.04);
    height: rem(120px);
    border-radius: 4px;
    margin-bottom: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    @media screen and (max-width: $bp-medium) {
        height: rem(145px);
        flex-wrap: wrap;
    }

    .monitor-name {
        line-height: rem(17px);
        letter-spacing: 0.01em;
        font-weight: bold;
        text-align: left;
        color: var(--text-offer-example);

        @media screen and (max-width: $bp-medium) {
            font-size: 0.9rem;
        }
    }
    .monitor-status {
        font-size: 0.7rem;

        &.ok {
            color: #b6dd3d;
        }

        &.good {
            color: #6cdb56;
        }

        &.bad {
            color: #c44031;
        }
    }

    .legend {
        flex: 0 0 auto;
        font-size: 0.7rem;
        position: relative;
        color: #aaaaaa;
        opacity: 0.7;

        @media screen and (max-width: $bp-medium) {
            font-size: 0.5rem;
        }

        .uptime {
            font-size: 0.8rem;
            opacity: 1;

            @media screen and (max-width: $bp-medium) {
                font-size: 0.7rem;
            }
        }
    }

    .monitor {
        svg {
            margin: 0;
            padding: 0;
            height: 34px;
            width: 100%;
            overflow: hidden;
        }
    }
}
</style>
